var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7847_26562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3333,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7847_26562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 33.9984C27.9499 33.9984 26.7708 33.5109 25.7958 32.5359C24.8208 31.5609 24.3333 30.3818 24.3333 28.9984C24.3333 27.6151 24.8208 26.4359 25.7958 25.4609C26.7708 24.4859 27.9499 23.9984 29.3333 23.9984C30.7166 23.9984 31.8958 24.4859 32.8708 25.4609C33.8458 26.4359 34.3333 27.6151 34.3333 28.9984C34.3333 30.3818 33.8458 31.5609 32.8708 32.5359C31.8958 33.5109 30.7166 33.9984 29.3333 33.9984ZM16.3333 23.0984V18.3734C16.3333 17.9568 16.4541 17.5818 16.6958 17.2484C16.9374 16.9151 17.2499 16.6734 17.6333 16.5234L23.6333 14.2734C23.8666 14.1901 24.0999 14.1484 24.3333 14.1484C24.5666 14.1484 24.7999 14.1901 25.0333 14.2734L31.0333 16.5234C31.4166 16.6734 31.7291 16.9151 31.9708 17.2484C32.2124 17.5818 32.3333 17.9568 32.3333 18.3734V21.4234C32.3333 21.7068 32.2083 21.9359 31.9583 22.1109C31.7083 22.2859 31.4416 22.3318 31.1583 22.2484C30.8583 22.1651 30.5583 22.1026 30.2583 22.0609C29.9583 22.0193 29.6499 21.9984 29.3333 21.9984C27.3999 21.9984 25.7499 22.6818 24.3833 24.0484C23.0166 25.4151 22.3333 27.0651 22.3333 28.9984C22.3333 29.5318 22.3958 30.0526 22.5208 30.5609C22.6458 31.0693 22.8249 31.5818 23.0583 32.0984C23.2083 32.4151 23.1624 32.6984 22.9208 32.9484C22.6791 33.1984 22.3999 33.2484 22.0833 33.0984C21.3833 32.7318 20.7416 32.2818 20.1583 31.7484C19.5749 31.2151 19.0583 30.6318 18.6083 29.9984C17.8916 29.0151 17.3333 27.9359 16.9333 26.7609C16.5333 25.5859 16.3333 24.3651 16.3333 23.0984ZM29.3333 28.9984C29.7499 28.9984 30.1041 28.8526 30.3958 28.5609C30.6874 28.2693 30.8333 27.9151 30.8333 27.4984C30.8333 27.0818 30.6874 26.7276 30.3958 26.4359C30.1041 26.1443 29.7499 25.9984 29.3333 25.9984C28.9166 25.9984 28.5624 26.1443 28.2708 26.4359C27.9791 26.7276 27.8333 27.0818 27.8333 27.4984C27.8333 27.9151 27.9791 28.2693 28.2708 28.5609C28.5624 28.8526 28.9166 28.9984 29.3333 28.9984ZM29.3333 31.9984C29.8499 31.9984 30.3249 31.8776 30.7583 31.6359C31.1916 31.3943 31.5416 31.0734 31.8083 30.6734C31.4416 30.4568 31.0499 30.2901 30.6333 30.1734C30.2166 30.0568 29.7833 29.9984 29.3333 29.9984C28.8833 29.9984 28.4499 30.0568 28.0333 30.1734C27.6166 30.2901 27.2249 30.4568 26.8583 30.6734C27.1249 31.0734 27.4749 31.3943 27.9083 31.6359C28.3416 31.8776 28.8166 31.9984 29.3333 31.9984Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.d039717265e3fa3d912deb88fa9e0916.svg";
export { ForwardRef as ReactComponent };